import React from 'react';

/* eslint-disable react/prefer-stateless-function */
export default class BaseComponent extends React.PureComponent {}
